module.exports = __webpack_public_path__ + "img/fidc-bg-1.c7e0c831.png";